interface WarningIconProps {
  height?: string;
  width?: string;
  innerFillColor?: string;
  outerFillColor?: string;
}

const WarningIcon = (props: WarningIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "41"}
      height={props.height || "36"}
      viewBox="0 0 41 36"
      fill="none"
    >
      <path
        d="M40.3073 30.7962L23.5038 1.734L23.5034 1.73309C22.8649 0.631573 21.7701 0 20.4998 0C19.2296 0 18.1347 0.631725 17.4957 1.734L0.691459 30.7969C0.0559718 31.8989 0.0559718 33.1631 0.691459 34.2649C1.32725 35.3675 2.42392 35.9998 3.70033 35.9998H37.2991C38.5755 35.9998 39.6723 35.3675 40.3079 34.2649C40.9434 33.1631 40.9434 31.8989 40.3073 30.7962Z"
        fill={props?.outerFillColor || "#B52F28"}
      />
      <path
        d="M40.3115 30.7962L23.508 1.734L23.5076 1.73309C22.8691 0.631573 21.7744 0 20.504 0C19.9636 0 19.4553 0.115449 19 0.331708C19.6148 0.623726 20.1326 1.10046 20.4995 1.73324L20.4999 1.73415L37.3034 30.7962C37.9394 31.8991 37.9394 33.1633 37.3039 34.2651C36.6681 35.3677 35.5714 36 34.295 36H37.3031C38.5795 36 39.6764 35.3677 40.312 34.2651C40.9476 33.1631 40.9476 31.8989 40.3115 30.7962Z"
        fill={props?.outerFillColor || "#AA2926"}
      />
      <path
        d="M20.492 13C21.7195 13 22.7848 14.0027 22.7234 15.2287L22.3814 22.0417C22.3287 23.0794 21.5309 23.9289 20.4918 23.9289C19.4528 23.9289 18.655 23.0794 18.6023 22.0417L18.2603 15.2287C18.1992 14.0027 19.2645 13 20.492 13Z"
        fill={props?.innerFillColor || "white"}
      />
      <path
        d="M20.489 30.2708C21.4229 30.2708 22.1812 29.509 22.1812 28.5807C22.1812 27.6481 21.4227 26.8906 20.489 26.8906C19.5554 26.8906 18.7969 27.6481 18.7969 28.5807C18.7969 29.509 19.5552 30.2708 20.489 30.2708Z"
        fill={props?.innerFillColor || "white"}
      />
    </svg>
  );
};

export default WarningIcon;
